<script lang="ts">
	import { postStore, setPostTitle } from '$lib/posts';
	import { SecureSanitizer } from '$lib/utils/secureSanitizer';
	import EditIcon from '$lib/components/common/EditIcon.svelte';
	import Input from '$lib/components/common/Input.svelte';
	import InputRow from '$lib/components/common/InputRow.svelte';

	export let create;

	function toTitleCase(str: string): string {
		return str.replace(
			/\w\S*/g,
			(txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
		);
	}

	const setTitle = async () => {
		if ($postStore.title !== undefined) {
			const title = $postStore.title ?? '';
			const TITLE_CASED = toTitleCase(title);
			const sanitizedTitle = await SecureSanitizer.sanitizeText(TITLE_CASED);
			$postStore.title = sanitizedTitle;
			if (!create && $postStore.id) {
				await setPostTitle($postStore.id, $postStore.title ?? '').catch((error) => {
					console.error('Error setting post title:', error);
				});
			}
		}
	};
</script>

<div class="flex w-full">
	<InputRow>
		<Input
			bind:value={$postStore.title}
			on:change={setTitle}
			inputType="text"
			minlength={4}
			maxlength={100}
			required
			size="lg"
			variant="default"
			className="flex-grow text-xl md:text-2xl lg:text-3xl 3xl:text-4xl font-bold"
		/>
		<div class="flex-1 relative top-0 -right-4">
			<EditIcon />
		</div>
	</InputRow>
</div>
